var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1657906116048,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5490,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src:\n            url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"),\n            url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"),\n            url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.333333 796.444444v56.888889h284.444445v-56.888889H341.333333z m-142.222222 56.888889C91.022222 853.333333 0 762.311111 0 654.222222 0 551.822222 73.955556 472.177778 170.666667 455.111111c11.377778-159.288889 147.911111-284.444444 312.888889-284.444444s295.822222 125.155556 312.888888 284.444444c96.711111 11.377778 170.666667 96.711111 170.666667 199.111111 0 108.088889-91.022222 199.111111-199.111111 199.111111h-568.888889z m568.888889-56.888889c79.644444 0 142.222222-62.577778 142.222222-142.222222 0-73.955556-51.2-130.844444-125.155555-142.222222l-45.511111-5.688889v-45.511111C728.177778 329.955556 614.4 227.555556 483.555556 227.555556S238.933333 329.955556 227.555556 460.8l-5.688889 45.511111-39.822223 5.688889C108.088889 523.377778 56.888889 580.266667 56.888889 654.222222 56.888889 733.866667 119.466667 796.444444 199.111111 796.444444h568.888889z",
    "p-id": 5491
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M484.408889 395.377778l201.159111 201.102222-40.220444 40.220444-201.159112-201.102222z",
    "p-id": 5492
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.737778 599.324444L483.84 398.222222l40.220444 40.220445-201.102222 201.159111z",
    "p-id": 5493
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M455.111111 455.111111h56.888889v455.111111H455.111111z",
    "p-id": 5494
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default ForwardRef;